import React, { useState, useEffect, useContext, Fragment } from 'react';
import { ProjectContext } from '../../../../../../context/Project';
import { PixelContext } from '../../../../../../context/Pixel';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import CreateButton from '../../../Button';
import useUser from '../../../../../../hooks/useUser';
import {
	Container,
	Row,
	Col,
	Button,
	Badge,
} from "reactstrap";
import '../../steps.scss';
import useLogin from '../../../../../../hooks/useLogin';
import Header from '../../Header';

function ContractorChoose() {
	const { getContractorId, setContractorId, getTotalBudget } = useContext(ProjectContext);

	const login = useLogin()
	const user = useUser();
	const { inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
	const { MetaPixel } = useContext(PixelContext);
	const [selectedContractorId, setSelectedContractorId] = useState('');
	const [contractorSelectionError, setContractorSelectionError] = useState(null);

	const verifiedContractorMessage = 'Verified contractor reviews coming soon';

	const handleSubmit = (event) => {
		event.preventDefault();
	}

	useEffect(() => {
		if (inProgress === InteractionStatus.None) {
			if (isAuthenticated) {
				let contractorId = getContractorId();

				if (contractorId) {
					setSelectedContractorId(contractorId);
				} else {
					MetaPixel.track('AddToCart', {
						value:    getTotalBudget(),
						currency: 'USD',
					});
				}

				user.getContractorList().then(error => {
					if (error) {
						setContractorSelectionError(error);
						setSelectedContractorId('');
					}
				});
			} else {
				MetaPixel.track('AddToCart', {
					value:    getTotalBudget(),
					currency: 'USD',
				});
				
				login.redirectToLogin(window.location.pathname, false);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);

	useEffect(() => {
		setContractorId(selectedContractorId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedContractorId]);

    return (
    	<Fragment>
			<Header title="Step 3: Select a Contractor" progress={42}/>
			<Container className="builde-cont contractor-choose">
				{
					user.userList && user.userList?.length > 0 && user.userList.map((contractor) => {
						return (
							<Row key={contractor.externalId} className='font-helvetica-world mb-2' onClick={() => { setSelectedContractorId(contractor.externalId); }}>
								<Col>
									<div className={`rounded-div${selectedContractorId === contractor.externalId ? ' selected' : ''}`}>
										<Row>
											<Col xs="8">
												<div>
													<h6 className={`fw-bold mb-1`}>{`${contractor.firstName} ${contractor.lastName}`}</h6>
												</div>
											</Col>
											<Col xs="4" className='position-relative text-end'>
												<div className="contractor-choose-check">
													<input type="checkbox" checked={selectedContractorId === contractor.externalId} readOnly={true}/>
												</div>
											</Col>
										</Row>
										<Row>
											<Col xs="8">
												<div>
													<span>Builde Solutions</span>
												</div>
											</Col>
											<Col xs="4"/>
										</Row>

										<Row className='mt-2'>
											<Col xs="8">
												<div className='mb-1'>
													<small>42 completed projects</small>
												</div>
											</Col>
											<Col xs="4" className='position-relative'>
												<div className="star-badge position-absolute end-0">
													<span className="star-icon">★</span>
													<span className="badge-number">4.5</span>
													<small className="preview text-secondary">Preview</small>
												</div>
											</Col>
										</Row>

										<Row className='mt-1'>
											<Col xs="6">
												<Badge className='project-type-badge text-primary' pill>Kitchens</Badge>
												{' '}
												<Badge className='project-type-badge text-primary' pill>Bathrooms</Badge>
											</Col>
											<Col xs="6" className='text-end'>
												<small className='text-secondary d-block mt-2 lh-1'>{verifiedContractorMessage}</small>
											</Col>
										</Row>

										<Row className='mt-2'>
											<Col xs="8">
												<div>
													<small className='fw-bold'>Price range: $$$</small>
												</div>
											</Col>
											<Col xs="4"/>
										</Row>
										<Row className='mt-3'>
											<Col>
												<Button className='w-100 view-profile-button'
													onClick={(e) => {alert(verifiedContractorMessage); e.preventDefault(); e.stopPropagation()}}>
														View Profile
												</Button>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						)
					})
				}
			</Container>
	    	<form className="form-base-dis my-3" onSubmit={handleSubmit}>
	    		<Container className="builde-cont">
					<Row>
		    			<Col xs={{size: 12}}>
							<div className="d-grid gap-2 m-b-1">
								<CreateButton className="continue"/>
							</div>							
						</Col>
					</Row>
		    	</Container>
	    	</form>
    	</Fragment>
    );
}

export default ContractorChoose;